<template>
  <div class="container" id="dataScreen" >
    <Header />
      <div class="content" v-show="currentPage=='1'" >
        <el-row>
          <el-col :span="7">
            <div class="content-left">
            <div class="chart-box">
                <p>趋势分布</p>
                <TrendChart />
            </div>
            <div class="chart-box">
              <p>电子信息产业(申请量)</p>
              <ElecChart />
            </div>
            <div class="chart-box">
              <p>技术分支(申请量)</p>
              <SkillsChart />
            </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="content-center">
              <ChinaMapChart />
                <div class="count2">
                  <div><p>142173</p><p>中国</p></div>
                  <div><p>126232</p><p>日本</p></div>
                  <div><p>91871</p><p>美国</p></div>
                  <div><p>41219</p><p>韩国</p></div>
                  <div><p>34123</p><p>德国</p></div>
               </div>
              <!-- <div :style="{padding:'0 20px', marginTop: '-38px'}"> -->
                <!-- <TABLEDATA /> -->
                <!-- <div class="left-stats">
                    <div class="stats-num">
                      <div><p :style="{fontSize: '22px'}">4554</p><p>专利申请量</p></div>
                      <div><p :style="{fontSize: '22px'}">1503</p><p>有效专利量</p></div>
                      <div><p :style="{fontSize: '22px'}">2613</p><p>发明专利申请量</p></div>
                      <div><p :style="{fontSize: '22px'}">854</p><p>有效发明专利量</p></div>
                    </div>
                </div> -->
              <!-- </div> -->
              <!-- 原来居右 -->
              <!-- <div class="count">
                <div><p>102098</p><p>中国</p><p></p></div>
                <div><p>95251</p><p>日本</p><p></p></div>
                <div><p>57479</p><p>美国</p><p></p></div>
                <div><p>30203</p><p>韩国</p><p></p></div>
                <div><p>23069</p><p>德国</p></div>
              </div> -->
            </div>
          </el-col>
          <el-col :span="7">
            <div class="content-right">
              <!-- <div class="suggest">
                  <p>黑龙江发展建议</p>
                  <el-tooltip placement="left" effect="customized">
                    <template #content>
                    <p :style="{marginBottom: '6px', marginTop:'15px'}">1、强化黑龙江省的重点技术分支：分立器件技术分支中的传感器方向和电子陶瓷材料，形成更加突出的技术优势</p>
                    <p :style="{marginBottom: '6px'}">2、弥补具有发展前景技术分支的不足，从集成电路和通信技术两个大方向规划补链路径</p>
                    <p :style="{marginBottom: '15px'}">3、向光伏能源和数字经济方向延展</p> 
                    </template>
                    <span>产业结构优化路径</span>
                  </el-tooltip>
                  <el-tooltip placement="left" effect="customized">
                    <template #content>
                    <p :style="{marginBottom: '6px', marginTop:'15px'}">1、重点技术领域优势企业进一步合作，优势企业进一步整合，巩固扩大现有优势。</p>
                    <p :style="{marginBottom: '6px'}">2、协同创新与强强联合，黑龙江省相关企业专利申请量与国际巨头之间差距悬殊，协同创新、强强联合才是发展之路。</p>
                    <p :style="{marginBottom: '15px'}">3、通过产学研助力企业发展，引进国内外优势企业落地黑龙江</p>
                    </template>
                    <span>重点企业培育路径建议</span>
                  </el-tooltip>
              </div> -->
              <div class="chart-box chart-zhuanli">
                <p>特色专利</p>
                <ZhuanLiTable /> 
              </div>
              <div class="chart-design">
                <p>技术分支-申请人类型</p>
                <TechBranchApplicantType />
              </div>
              <div class="chart-gdpRank">
                <p>各地市国民经济分类排名(申请量)</p>
                <GDPChart /> 
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    <!-- <div v-show="currentPage=='2'" class="dev-box">
      <DevHistory/>
    </div> -->
    <div v-show="currentPage=='3'" class="dev-box">
      <Page2 />
    </div>
    <!-- <div class="dev" @click="changePage(currentPage)">{{currentPage ? '发展历程' : '大屏数据'}}</div> -->
  </div>
  <div class="tab-btn">
    <span @click="changePage('1')" :class="{'active': currentPage === '1'}" class="span1"><span class="status-point"></span> 导航全景</span>
    <!-- <span @click="changePage('2')" :class="{'active': currentPage === '2'}">发展历程</span> -->
    <span @click="changePage('3')" :class="{'active': currentPage === '3'}" class="span1"><span class="status-point"></span>省内聚焦</span>
  </div>
</template>

<script>
import ChinaMapChart from './components/chinaMapChart.vue'
import TrendChart from './components/trendChart.vue'
import SkillsChart from './components/skillsChart.vue'
import ElecChart from './components/elecChart.vue'
import GDPChart from './components/gdpChart.vue'
import TechBranchApplicantType from './components/techBranchApplicantType.vue'
// import DevHistory from './components/devHistory.vue'
import Header from './components/header.vue'
import Page2 from './components/page2.vue'
import ZhuanLiTable from './components/zhuanLiTable.vue'
import {ref, onMounted, onUnmounted} from 'vue'
export default {
  name: 'App',
  components: {
    ChinaMapChart,
    Header,
    // TABLEDATA,
    TrendChart,
    SkillsChart,
    GDPChart,
    TechBranchApplicantType,
    // DevHistory,
    Page2,
    ZhuanLiTable,
    ElecChart
  },
  data(){
    return {
    }
  },
  setup() {
    let currentPage = ref('1');
    const handleScreenAuto= () => {
    let x=document.documentElement.clientWidth;
    let y = document.documentElement.clientHeight;
    document.querySelector('#dataScreen').style.transform = `scale(${x/1920},${y/1080})`
    }
    function changePage(val) {
      currentPage.value = val;      
    }
    onMounted(() => {
      handleScreenAuto();
       //初始化自适应  ----在刚显示的时候就开始适配一次
      // document.querySelector('#dataScreen').style.transform = `scale(${handleScreenAuto})`
      //绑定自适应函数   ---防止浏览器栏变化后不再适配
      window.onresize = () => handleScreenAuto();
    });
    onUnmounted(() => {
       window.onresize = null;
    });
    return {changePage, currentPage};
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  font-family: 'Microsoft YaHei';
}
body{
   background: #000746;
   background: linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0); 
   width: 100%;
   height: 100%;
   overflow: hidden;
   text-size-adjust: none;
   -webkit-text-size-adjust: none;
   -webkit-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
   -moz-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
   -o-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
   -ms-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
}
html{
     text-size-adjust: none;
   -webkit-text-size-adjust: none;
}
#app {
  background: #000746;
  background: linear-gradient(to bottom right, #020b4e 22%,#0a1483,#000d51,#1541a0);
  -webkit-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
  -moz-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
  -o-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
  -ms-background:linear-gradient(to bottom right, #020b4e 22%, #0a1483,#000d51,#1541a0);
  height: 100%;
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
}
.dev{
  position: absolute;
  top: 16px;
  right: 20px;
  color: #fff;
  background-color: #02eeea;
  font-weight: 600;
  border-radius: 20px;
  padding: 12px 32px;
  cursor: pointer;
  font-size: 20px;
}
.content-left{
  color: #fff;
  height: 100%;
}
.count {
  position: absolute;
  top: 120px;
  right: 20px;
  background-color: rgb(128,217,236, 0.2);
}
.count div{
 margin-bottom: 10px;
 padding: 0px 10px;
 text-align: center;
}
.count div p:nth-child(1) {
  font-size: 25px;
  padding-top: 20px;
  margin-bottom: 3px;
}
.count div p:nth-child(2) {
  font-size: 14px;
  color: #fff;
  margin-top: 3px;
}
.count div p:nth-child(3) {
  width: 75px;
  border-bottom: 1px solid #80d9fb30;
  padding-top: 15px;
}
.count div p{
   color: #02eeea;
}
.content-center{
  position: relative;
  padding: 0 20px;
}
.content-right{
  color: #fff;
}
.stats-num{
  display: flex;
  justify-content: space-between;
  /* margin-top: 30px; */
}
.stats-num p{
  /* color: black; */
  font-weight: 600;
}
.stats-num div{
  /* padding: 5px 20px; */
  text-align: center;
  font-size: 15px;
  width: 150px;
  padding: 8px 0;
  background-color: rgb(128,217,236, 0.2);
}
.stats-num p:nth-child(1) {
  margin-bottom: 4px;
  color: #02eeea;
}
.stats-num p:nth-child(2) {
  color: #fff;
}
/* .content-left .stats-num div:nth-child(1){
  background-color: #fde000;
}
.content-left .stats-num div:nth-child(2){
  background-color: #14f1ff;
}
.content-left .stats-num div:nth-child(3){
  background-color: #f5007f;
}
.content-left .stats-num div:nth-child(4){
  background-color: #9b00fe;
} */
.chart-box,.chart-design, .chart-zhuanli{
  /* border: 1px solid red; */
  margin-top: 20px;
  border-radius: 25px;
  border: 1px solid #088DF2;
  padding-left: 20px;
  box-shadow: 0px 0px 6px 1px #088df2;
}
.chart-zhuanli .el-row{
  flex-wrap: nowrap;
}
.chart-design{
  padding: 20px 0;
}
.chart-design p {
  padding-left: 20px;
}
.chart-box{
  padding-top: 20px;
}
.chart-branchRank,.chart-gdpRank{
  border-radius: 25px;
  border: 2px solid rgba(51, 111, 255, .38);
  padding: 20px 20px;
  margin-top: 20px;
   border: 1px solid #088DF2;
   box-shadow: 0px 0px 6px 1px #088df2;
}
.chart-zhuanli{
  padding-top: 20px;
  height: 235px;
}
.chart-branchRank p, .chart-gdpRank p {
  padding-left: 2px;
}
.chart-box{
  /* border: 1px solid #336FFF; */
  padding: 10px 10px;
  margin-top: 20px;
  border-radius: 25px;
  border: 2px solid rgba(51, 111, 255, .38);
     border: 1px solid #088DF2;
   box-shadow: 0px 0px 6px 1px #088df2;
}
.chart-box p {
  padding-left: 10px;
  /* margin-bottom: 20px; */
  padding-top: 10px;
}
.left-stats {
  padding: 30px;
}
.suggest {
  margin-top: 20px;
  border-radius: 25px;
  border: 2px solid rgba(51, 111, 255, .38);
     border: 1px solid #088DF2;
   box-shadow: 0px 0px 6px 1px #088df2;
  /* padding-left: 20px; */
  padding: 20px;
}
.suggest p {
  font-size: 16px;
  color: #80D9FB;
}
.suggest span {
  display: inline-block;
  margin-right: 20px;
  font-size: 16px;
  margin-top: 10px;
  border: 1px solid #80D9FB;
  border-radius: 12px;
  width: 160px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  padding: 10px;
}
.el-table__inner-wrapper:before{
  background-color: transparent!important;
}
#dataScreen{
  /* position: fixed; */
  width: 1920px;
  height: 1080px;
  transform-origin: left top;
}
.tab-btn{
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  width: 500px;
  text-align: center;
}
.tab-btn span.span1 {
  display: inline-block;
  /* width: 100px; */
  /* background-color: #02eeea; */
  text-align: center;
  font-size: 16px;
  color: #d1d6e4;
  padding: 10px 40px;
  border-radius: 20px;
  cursor: pointer;
  /* background: #17377c; */
  margin: 0 6px;
  background-color: rgb(128, 217, 236, 0.2);
   /* background: linear-gradient(45deg, #1c3068, #29639e); */
}
.tab-btn span.status-point {
  background-color: #02eeea;
  display: inline-block;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  vertical-align: middle;
}
.tab-btn span.active{
   /* border: 1px solid #02eeea;
   box-shadow: 0px 0px 2px 1px #02eeea; */
   color: #fff;
}
.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background-color: #230160;
  color: #fff;
  /* background: linear-gradient(90deg, rgb(159, 229, 151), rgb(204, 229, 129)); */
}

.el-popper.is-customized .el-popper__arrow::before {
  /* background: linear-gradient(45deg, #b2e68d, #bce689); */
  background-color: #230160;
  color: #fff;
  right: 0;
}
.count2{
  display: flex;
  position: absolute;
  bottom: 80px;
  left: 62px;
  background: linear-gradient(45deg, #1c3068, #29639e);
  margin:  0 auto;
  border-radius: 60px;
}
.count2 div{
  padding: 15px 30px;
  text-align: center;
  color: #fff;
}
.count2 div p{
   color: #02eeea;
}
.count2 div p:nth-child(1) {
  font-size: 25px;
  padding-top: 20px;
  margin-bottom: 3px;
}
.count2 div p:nth-child(2) {
  font-size: 14px;
  color: #fff;
  margin-top: 3px;
}
</style>
